import "./App.css";
import AppRoutes from "./Routes";
import ScrollToTop from "./component/ScrollToTop";
import useHeaderColor from "./hooks/useHeaderColor";
import useOnLoad from "./hooks/useOnLoad";
import { ThemeProvider } from "styled-components";
import theme from "./theme/theme";
import { GlobalStyle } from "./style/global.style";

function App() {
  useHeaderColor();
  useOnLoad();
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <ScrollToTop />
      <AppRoutes />
    </ThemeProvider>
  );
}

export default App;
